export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9385.50a78ed5.jpg";